module.exports = __webpack_public_path__ + "assets/img/notice.b9612ee2.svg";